import React from "react";

export const ExternalLink: React.FC<{
  href: string;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}> = (props) => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    href={props.href}
    className={props.className}
    onClick={props.onClick}
  >
    {props.children}
  </a>
);
